import { useState } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getHasMessagingAccess } from '../selectors/userSelectors/getHasMessagingAccess';
import { getWhatsAppCreateUrl } from '../urls/inboxSettingsUrls';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { getIsUngatedForTemplateIframe } from '../selectors/gateSelectors';
import { usePromptDismissal } from '../contextual-prompts/hooks/usePromptDismissals';
import { UserPromptType } from '../contextual-prompts/constants/userPromptTypes';
import { getDismissedAt } from '../contextual-prompts/operators/userPromptDataGetters';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { isSucceeded } from 'conversations-async-data/async-data/operators/statusComparators';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getIsDisabledForAcceptanceTest } from '../new-feature-onboarding/operators/getIsDisabledForAcceptanceTest';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WhatsAppCoachingModal = ({
  children
}) => {
  const hasMessagingAccess = useSelector(getHasMessagingAccess);
  const {
    openUpgradeModal
  } = useUpgradeModal('whatsapp-messaging-access-inbox');
  const inboxId = useSelector(getCurrentInboxId);
  const {
    asyncPromptData,
    dismissPrompt
  } = usePromptDismissal(UserPromptType.WHATS_APP_UPGRADE_PROMPT);
  const allRequestsResolved = isSucceeded(asyncPromptData);
  const userPromptData = getData(asyncPromptData);
  const isUngatedForTemplateIframe = useSelector(getIsUngatedForTemplateIframe);
  const [coachingTipVisibility, setCoachingTipVisibility] = useState(true);
  const handlePopoverOpenChange = () => {
    setCoachingTipVisibility(false);
    void dismissPrompt();
  };
  const isDisabledForAcceptanceTest = getIsDisabledForAcceptanceTest();
  if (!isUngatedForTemplateIframe || inboxId === null || !userPromptData || !allRequestsResolved || isDisabledForAcceptanceTest) {
    return children;
  }
  const shouldHideModal = getDismissedAt(userPromptData) > 0;
  if (shouldHideModal) {
    return children;
  }
  return /*#__PURE__*/_jsx(Popover, {
    "data-test-id": "custom-views-agent-coaching-tip",
    use: "shepherd",
    inlineSize: "367px",
    open: coachingTipVisibility,
    showCloseButton: true,
    onOpenChange: handlePopoverOpenChange,
    placement: "top right",
    autoPlacement: false,
    content: {
      header: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.new-feature-onboarding.whatsApp.modal.header"
        })
      }),
      body: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.new-feature-onboarding.whatsApp.modal.body"
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), hasMessagingAccess ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "conversations-inbox-ui.new-feature-onboarding.whatsApp.modal.isEligibleCTA_jsx",
          options: {
            external: true,
            href: 'https://knowledge.hubspot.com/inbox/connect-whatsapp-to-the-conversations-inbox#before-you-get-started'
          },
          elements: {
            UILink: Link
          }
        }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "conversations-inbox-ui.new-feature-onboarding.whatsApp.modal.nonEligibleCTA_jsx",
          options: {
            external: true,
            href: 'https://knowledge.hubspot.com/inbox/connect-whatsapp-to-the-conversations-inbox#before-you-get-started'
          },
          elements: {
            UILink: Link
          }
        })]
      }),
      footer: /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [hasMessagingAccess ? /*#__PURE__*/_jsx(Button, {
          use: "primary",
          href: getWhatsAppCreateUrl({
            inboxId
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'conversations-inbox-ui.new-feature-onboarding.whatsApp.modal.button.connect'
          })
        }) : /*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: openUpgradeModal,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'conversations-inbox-ui.new-feature-onboarding.whatsApp.modal.button.upgrade'
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "secondary",
          onClick: handlePopoverOpenChange,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-ui.new-feature-onboarding.whatsApp.modal.button.later"
          })
        })]
      })
    },
    children: children
  });
};
WhatsAppCoachingModal.displayName = 'WhatsAppCoachingModal';
export default WhatsAppCoachingModal;